import { scrollToElementWithId } from 'src/utils/scrollToElementWithId';

import s from '../Article.module.scss';

export interface NavBarProps {
  title: string;
  id: string;
}

export function NavBar({ menu }: { menu: NavBarProps[] }) {
  return (
    <div className={s.navbar}>
      <p className={s.navbarTitle} data-qa="side-menu-title">
        Содержание
      </p>
      <ul className={s.navbarItems}>
        {menu.map(({ title, id }) => (
          <li
            key={id}
            className={s.navbarItem}
            onClick={() => scrollToElementWithId(id)}
            data-qa="side-menu-item"
          >
            {title}
          </li>
        ))}
      </ul>
    </div>
  );
}
